import {
  Card,
  CardDescription,
  CardHeader,
  CardTitle,
} from "@/components/Base/Card";

type CreateShopButtonProps = {
  onClick?: () => void;
};

export const CreateShopButton = ({ onClick }: CreateShopButtonProps) => {
  return (
    <button className="duration-500 hover:scale-110" onClick={onClick}>
      <Card>
        <CardHeader>
          <CardTitle>Create Shop</CardTitle>
          <CardDescription>
            Create a new shop and setup subscription
          </CardDescription>
        </CardHeader>
      </Card>
    </button>
  );
};
